import { energyApi } from "utilities/Axios";

export const getLicenseInfo = () => {
  return energyApi.get("/License/GetLicenseInfo");
};